import { ca } from '@cian/analytics';

import { adAnalyticsCategory } from '../../../../../scripts/services/analytics.service';

export function trackUtilitiesTermsFilling(product) {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'enter_compayments',
    products: [product],
  });
}

export function trackUtilitiesTermsCheckboxClicking(product) {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'Click',
    label: 'meters_checkbox',
    products: [product],
  });
}

export function trackUtilitiesTermsActions(utilitiesTersm, offerId) {
  const product = {
    id: offerId,
    offerType: 'offer',
    position: 1,
  };

  if (utilitiesTersm.price) {
    trackUtilitiesTermsFilling(product);
  }

  if (utilitiesTersm.flowMetersNotIncludedInPrice) {
    trackUtilitiesTermsCheckboxClicking(product);
  }
}
